import { render, staticRenderFns } from "./DistributorManager.vue?vue&type=template&id=c6dea65c"
import script from "./DistributorManager.vue?vue&type=script&lang=js"
export * from "./DistributorManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports